import { render, staticRenderFns } from "./RightsAssignment.vue?vue&type=template&id=787c8993"
import script from "./RightsAssignment.vue?vue&type=script&lang=js"
export * from "./RightsAssignment.vue?vue&type=script&lang=js"
import style0 from "./RightsAssignment.vue?vue&type=style&index=0&id=787c8993&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports